export default __webpack_public_path__ + "static/media/gpay.939a4a09.png";